(function(){
  var root=document.querySelector('.cnd');
  if(!root) return;
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- reveals --- */
  var rvs=document.querySelectorAll('.cnd-rv');
  if(reduce||!('IntersectionObserver' in window)){
    for(var a=0;a<rvs.length;a++) rvs[a].classList.add('vis');
  } else {
    var io=new IntersectionObserver(function(es){
      es.forEach(function(e){
        if(e.isIntersecting){
          var sib=e.target.parentNode?e.target.parentNode.children:[];
          var k=Array.prototype.indexOf.call(sib,e.target);
          e.target.style.transitionDelay=(Math.min(k,6)*0.085)+'s';
          e.target.classList.add('vis');
          io.unobserve(e.target);
        }
      });
    },{threshold:0.16,rootMargin:'0px 0px -8% 0px'});
    for(var b=0;b<rvs.length;b++) io.observe(rvs[b]);
  }

  /* --- contadores --- */
  var nums=document.querySelectorAll('.cnd-dato b[data-n]');
  function fmt(v,el){
    var s=String(v);
    if(el.getAttribute('data-sep')) s=s.replace(/\B(?=(\d{3})+(?!\d))/g,'.');
    return s;
  }
  if('IntersectionObserver' in window){
    var io2=new IntersectionObserver(function(es){
      es.forEach(function(e){
        if(!e.isIntersecting) return;
        var el=e.target, end=parseInt(el.getAttribute('data-n'),10), t0=null;
        if(reduce){ el.textContent=fmt(end,el); io2.unobserve(el); return; }
        function step(ts){
          if(!t0) t0=ts;
          var p=Math.min((ts-t0)/1150,1);
          var e2=1-Math.pow(1-p,3);
          el.textContent=fmt(Math.round(end*e2),el);
          if(p<1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
        io2.unobserve(el);
      });
    },{threshold:0.5});
    for(var c=0;c<nums.length;c++) io2.observe(nums[c]);
  } else {
    for(var d=0;d<nums.length;d++) nums[d].textContent=fmt(parseInt(nums[d].getAttribute('data-n'),10),nums[d]);
  }

  function clamp(v,a,b){ return v<a?a:(v>b?b:v); }

  /* --- barra de compra fija ---
     Aparece al pasar la portada y se retira sola al llegar al bloque de compra,
     para no duplicar el botón. Funciona también con animaciones reducidas. */
  var bar=document.getElementById('cndBar');
  var heroEl=document.querySelector('.cnd-hero,.cnd-hp');
  var compraEl=document.querySelector('.cnd-compra,.cnd-reserva');
  function pintaBarra(){
    if(!bar) return;
    var vh=window.innerHeight;
    var pasadaPortada=window.innerWidth<=640 || window.scrollY > (heroEl?heroEl.offsetHeight:vh)*0.7; /* móvil: desde la primera pantalla */
    var yaEnCompra=compraEl ? compraEl.getBoundingClientRect().top < vh*0.8 : false;
    var ver=pasadaPortada && !yaEnCompra;
    bar.classList.toggle('on',ver);
    bar.setAttribute('aria-hidden',ver?'false':'true');
  }
  window.addEventListener('scroll',pintaBarra,{passive:true});
  window.addEventListener('resize',pintaBarra,{passive:true});
  pintaBarra();

  /* --- secuencia cinematográfica --- */
  var wrap=document.getElementById('cndSeq');
  if(!wrap||reduce) return;
  var frames=wrap.querySelectorAll('.cnd-frame');
  var rails=wrap.querySelectorAll('.cnd-rail-i');
  var n=frames.length;
  if(n<2) return;
  var hero=document.querySelector('.cnd-hero-bg img');

  var destino=0, actual=0, corriendo=false, primera=true;

  /* smootherstep: entra y sale sin tirón, la derivada es 0 en los extremos */
  function suave(t){ return t*t*t*(t*(t*6-15)+10); }

  var stage=wrap.querySelector('.cnd-stage');
  var stickyRoto=false;

  /* Si el escenario no se queda pegado (Safari, o algún ancestro que lo impida),
     dejamos de animar y apilamos los fotogramas en vertical. Vale más una página
     sencilla que funcione que una secuencia que se ve en negro. */
  function compruebaSticky(){
    if(stickyRoto||!stage) return;
    var r=wrap.getBoundingClientRect();
    if(r.top>-60 || r.bottom<window.innerHeight+60) return;   /* aún no estamos dentro del tramo */
    if(stage.getBoundingClientRect().top>-60) return;          /* está pegado: todo bien */
    stickyRoto=true;
    (wrap.closest('.cnd')||root).classList.add('cnd-nosticky');
    for(var i=0;i<frames.length;i++){
      var f=frames[i];
      f.style.opacity=''; f.style.transform='';
      if(f.firstElementChild) f.firstElementChild.style.transform='';
      if(f.lastElementChild){ f.lastElementChild.style.opacity=''; f.lastElementChild.style.transform=''; }
    }
  }

  function objetivo(){
    var r=wrap.getBoundingClientRect();
    /* medir contra la altura REAL del escenario, no contra window.innerHeight:
       en móvil la barra del navegador cambia innerHeight y el cálculo se desviaba */
    var total=r.height-(stage?stage.offsetHeight:window.innerHeight);
    if(total<=0) return 0;
    return clamp((0-r.top)/total,0,1);
  }

  /* Cada capítulo se sostiene quieto un tramo y solo cruza en una ventana corta.
     Así se lee como un corte de montaje y no como una masa que muta sin parar. */
  var RETENCION=0.34, CRUCE=0.40;

  function pinta(p){
    compruebaSticky();
    if(stickyRoto) return;
    var vh=window.innerHeight;
    if(hero){
      var hs=clamp(window.scrollY/vh,0,1);
      hero.style.transform='scale('+(1.06+hs*0.10).toFixed(4)+') translateY('+(hs*4).toFixed(2)+'%)';
    }
    var u=p*(n-1);
    var i=Math.min(Math.floor(u),n-2);
    var t=u-i;
    var w=suave(clamp((t-RETENCION)/CRUCE,0,1));

    for(var k=0;k<n;k++){
      var op = k===i ? 1-w : (k===i+1 ? w : 0);
      var f=frames[k];
      f.style.opacity=op.toFixed(4);
      if(op<0.004) continue;
      var im=f.firstElementChild;
      if(im){
        var edad=clamp((u-k+1)/2,0,1);
        im.style.transform='scale('+(1.15-edad*0.13).toFixed(4)+') translateZ(0)';
      }
      var cap=f.lastElementChild;
      if(cap){
        var co=clamp((op-0.42)/0.36,0,1);
        cap.style.opacity=co.toFixed(3);
        cap.style.transform='translateX(-50%) translateY('+((1-co)*26).toFixed(1)+'px)';
      }
    }
    var act = w>0.5 ? i+1 : i;
    for(var j=0;j<rails.length;j++) rails[j].classList.toggle('on',j===act);
  }

  /* Lo pintado persigue al scroll con inercia: quita el escalón de la rueda del ratón */
  var ultimoPintado=0;
  function bucle(ts){
    ultimoPintado=ts||0;
    var d=destino-actual;
    if(Math.abs(d)<0.0002){ actual=destino; pinta(actual); corriendo=false; return; }
    actual+=d*0.14;
    pinta(actual);
    if(!stickyRoto) requestAnimationFrame(bucle); else corriendo=false;
  }
  function arranca(ev){
    destino=objetivo();
    if(primera){ actual=destino; primera=false; }
    /* Safari en iOS puede frenar requestAnimationFrame durante el scroll por inercia.
       Si lleva más de 140 ms sin pintar, pintamos aquí mismo aunque sea sin suavizado. */
    if(ev && corriendo && typeof performance!=='undefined' && performance.now()-ultimoPintado>140){
      actual=destino; ultimoPintado=performance.now(); pinta(actual);
    }
    if(!corriendo && !stickyRoto){ corriendo=true; requestAnimationFrame(bucle); }
  }
  window.addEventListener('scroll',arranca,{passive:true});
  window.addEventListener('resize',arranca,{passive:true});
  arranca();
})();

/* --- unidades y formato: pasos +/- y sincronizacion entre el bloque y la barra --- */
(function(){
  var raiz=document;

  var cantidades=raiz.querySelectorAll('input[name="quantity"]');
  function propaga(v,origen){
    for(var i=0;i<cantidades.length;i++) if(cantidades[i]!==origen) cantidades[i].value=v;
  }
  for(var i=0;i<cantidades.length;i++){
    (function(el){
      el.addEventListener('input',function(){
        var v=parseInt(el.value,10); if(!v||v<1) v=1;
        propaga(v,el);
      });
      el.addEventListener('blur',function(){
        var v=parseInt(el.value,10); if(!v||v<1){ v=1; el.value=1; }
        propaga(v,el);
      });
    })(cantidades[i]);
  }

  var pasos=raiz.querySelectorAll('.cnd-bar-q button');
  for(var j=0;j<pasos.length;j++){
    (function(b){
      b.addEventListener('click',function(){
        var inp=b.parentNode.querySelector('input');
        var v=parseInt(inp.value,10)||1;
        v = b.hasAttribute('data-mas') ? v+1 : v-1;
        if(v<1) v=1;
        inp.value=v; propaga(v,inp);
      });
    })(pasos[j]);
  }

  /* si algun dia hay varios formatos: el precio y el resto de formularios siguen al desplegable */
  var selects=raiz.querySelectorAll('select[name="id"]:not(.cnd-niv-sel)');
  var ocultos=raiz.querySelectorAll('input[type="hidden"][name="id"]');
  var precios=raiz.querySelectorAll('[data-precio],[data-precio-barra]');
  for(var k=0;k<selects.length;k++){
    (function(s){
      s.addEventListener('change',function(){
        var o=s.options[s.selectedIndex], pr=o.getAttribute('data-p');
        for(var a=0;a<selects.length;a++) if(selects[a]!==s) selects[a].value=o.value;
        for(var b2=0;b2<ocultos.length;b2++) ocultos[b2].value=o.value;
        if(pr) for(var c=0;c<precios.length;c++) precios[c].textContent=pr;
        /* en los clubes, junto al precio va lo que cuesta el mismo cafe suelto */
        var antes=o.getAttribute('data-antes'), cajas=raiz.querySelectorAll('[data-ahorro]');
        for(var d2=0;d2<cajas.length;d2++){
          if(antes){ cajas[d2].textContent=antes; cajas[d2].hidden=false; }
          else { cajas[d2].hidden=true; }
        }
      });
    })(selects[k]);
  }
})();

/* --- orden del catalogo: el desplegable navega solo --- */
(function(){
  var s=document.querySelector('[data-orden]');
  if(!s) return;
  s.addEventListener('change',function(){
    var u=new URL(window.location.href);
    u.searchParams.set('sort_by',s.value);
    u.searchParams.delete('page');
    window.location.href=u.toString();
  });
})();

/* --- club: cada tarjeta lleva su propio formato, precio y ahorro --- */
(function(){
  var tarjetas=document.querySelectorAll('.cnd-niv');
  for(var i=0;i<tarjetas.length;i++){
    (function(t){
      var sel=t.querySelector('.cnd-niv-sel');
      if(!sel) return;
      var pr=t.querySelector('[data-niv-precio]'), ah=t.querySelector('[data-niv-antes]');
      sel.addEventListener('change',function(){
        var o=sel.options[sel.selectedIndex];
        if(pr && o.getAttribute('data-p')) pr.textContent=o.getAttribute('data-p');
        if(ah){
          var a=o.getAttribute('data-antes');
          if(a){ ah.textContent=a; ah.hidden=false; } else { ah.hidden=true; }
        }
      });
    })(tarjetas[i]);
  }
})();
